import { Button } from 'reactstrap';
import { useState } from 'react';
// import Swal from 'sweetalert2';

const Info = ({ title, text,onCopy }) => {

    const [copiedText, setCopiedText]=useState('');

  const handleCopy = (data) => {
    navigator.clipboard.writeText(data);
    setCopiedText(text);
    setTimeout(()=>setCopiedText(''),3000);
  };
  return (
    <div className='amount-div'>
      {copiedText&&(
        <div style={{
          width:'100%',
          backgroundColor:"#07C160",
          position:"fixed",
          transform:'translateX(-50%) ',
          color:'white',
          top:"0px",
          left:"50%",
          zIndex:9999,
          fontSize:'14px',
          padding:'7px 0 7px 0'
        }}>
          copy:{copiedText}

        </div>
      )}
      <p>{title}</p>
      <div className='amount-email'>
        <p>{text}</p>
        <div>
          <Button color='primary' size='sm' outline onClick={() => handleCopy(text)}>
            COPY
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Info;
